import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  CREATE_LOAN: 'CREATE_LOAN',
  SIGN_LOAN: 'SIGN_LOAN',
  SIGN_LOAN_INSURANCE: 'SIGN_LOAN_INSURANCE',
  CONFIRM_LOAN: 'CONFIRM_LOAN',
  CONFIRM_LOAN_INSURANCE: 'CONFIRM_LOAN_INSURANCE',
  SIGN_INFO_OBLIGATIONS: 'SIGN_INFO_OBLIGATIONS',
  CONFIRM_INFO_OBLIGATIONS: 'CONFIRM_INFO_OBLIGATIONS',
  SIGN_POST_FINANCING: 'SIGN_POST_FINANCING',
  CONFIRM_POST_FINANCING: 'CONFIRM_POST_FINANCING',
  FETCH_LOANS: 'FETCH_LOANS',
  FETCH_ANONYMIZED_LOANS: 'FETCH_ANONYMIZED_LOANS',
  UPDATE_LOANS_ENCASHMENT_STATUS: 'UPDATE_LOANS_ENCASHMENT_STATUS',
  CARD_PAYMENT: 'CARD_PAYMENT',
  ADD_LOAN_DOCUMENT: 'ADD_LOAN_DOCUMENT',
  REMOVE_LOAN_DOCUMENT: 'REMOVE_LOAN_DOCUMENT',
  WITHDRAW_LOAN: 'WITHDRAW_LOAN',
};

export default {
  createLoan: loanData => {
    return apiClient.post('/loan', loanData, {
      apiCallId: apiCallIds.CREATE_LOAN,
    });
  },

  cardPayment: (loanId, data) => {
    return apiClient.post(`loan/${loanId}/cardPaymentSignature`, data, {
      apiCallId: apiCallIds.CARD_PAYMENT
    })
  },

  signLoan: loanId => {
    return apiClient.post(`/loan/${loanId}/sign`, undefined, { apiCallId: apiCallIds.SIGN_LOAN });
  },

  signLoanInsurance: loanId => {
    return apiClient.post(`/loan/${loanId}/signInsurance`, undefined, { apiCallId: apiCallIds.SIGN_LOAN_INSURANCE });
  },

  confirmLoan: (loanId, token) => {
    return apiClient.post(
      `/loan/${loanId}/confirm`,
      { token },
      { apiCallId: apiCallIds.CONFIRM_LOAN }
    );
  },

  confirmLoanInsurance: (loanId, token) => {
    return apiClient.post(
      `/loan/${loanId}/confirmInsurance`,
      { token },
      { apiCallId: apiCallIds.CONFIRM_LOAN_INSURANCE }
    );
  },

  signInfoObligations: loanId => {
    return apiClient.post(`/loan/${loanId}/signInfoObligations`, undefined, {
      apiCallId: apiCallIds.SIGN_INFO_OBLIGATIONS,
    });
  },

  confirmInfoObligations: (loanId, token) => {
    return apiClient.post(
      `/loan/${loanId}/confirmInfoObligations`,
      { token },
      { apiCallId: apiCallIds.CONFIRM_INFO_OBLIGATIONS }
    );
  },

  signPostFinancing: loanId => {
    return apiClient.post(`/loan/${loanId}/signPostFinancing`, undefined, {
      apiCallId: apiCallIds.SIGN_POST_FINANCING,
    });
  },

  confirmPostFinancing: (loanId, token) => {
    return apiClient.post(
      `/loan/${loanId}/confirmPostFinancing`,
      { token },
      { apiCallId: apiCallIds.CONFIRM_POST_FINANCING }
    );
  },

  resendSmsCodeLoan: loanId => {
    return apiClient.get(`/loan/${loanId}/resendSmsCode`);
  },

  fetchLoans: options => {
    return apiClient.get(`/loan?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_LOANS,
    });
  },

  fetchAnonymizedLoans: options => {
    return apiClient.get(`/loan/anonymized?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ANONYMIZED_LOANS,
    });
  },

  updateLoansEncashmentStatus: (loans, encashmentStatus) => {
    return apiClient.put(`/loan/updateEncashmentStatus`, { loans, encashmentStatus }, {
      apiCallId: apiCallIds.UPDATE_LOANS_ENCASHMENT_STATUS,
    });
  },

  disableAutomaticPayments: loanId => {
    return apiClient.get(`/loan/${loanId}/disableAutomaticPayments`);
  },

  disableSavedCard: loanId => {
    return apiClient.get(`/loan/${loanId}/disableSavedCard`);
  },

  addLoanDocument: (loanId, document) => {
    return apiClient.post(`/loan/${loanId}/addLoanDocument`, document, {
      apiCallId: apiCallIds.ADD_LOAN_DOCUMENT
    });
  },

  removeLoanDocument: (loanId, fileId) => {
    return apiClient.delete(`/loan/${loanId}/removeLoanDocument/`, {fileId: fileId}, {
      apiCallId: apiCallIds.REMOVE_LOAN_DOCUMENT
    });
  },

  withdrawLoan: loanId => {
    return apiClient.post(`/loan/${loanId}/withdraw`, undefined, {
      apiCallId: apiCallIds.WITHDRAW_LOAN,
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/loans/api/index.js